import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ESPECIALIDADE_LABEL, type EspecialidadeProf } from "../../types";
import { criarProfissional } from "../queries";
import { ESPECIALIDADES_ORDEM } from "../types";

/** Cadastro de profissional (P0.1). Só nome + especialidade são necessários. */
export function NovoProfissional() {
  const nav = useNavigate();
  const [nome, setNome] = useState("");
  const [especialidade, setEspecialidade] = useState<EspecialidadeProf>("fono");
  const [registro, setRegistro] = useState("");
  const [contato, setContato] = useState("");

  async function salvar() {
    if (!nome.trim()) return;
    const id = await criarProfissional({
      nome,
      especialidade,
      registro_classe: registro || null,
      contato: contato || null,
    });
    nav(`/elo/profissional/${id}`, { replace: true });
  }

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>← voltar</button>
      <h1 className="tela-titulo">novo profissional</h1>
      <p className="tela-sub">nome e especialidade bastam. fica só neste aparelho.</p>

      <div className="card">
        <div className="campo">
          <label>nome</label>
          <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="ex.: Ana Souza" autoFocus />
        </div>
        <div className="campo">
          <label>especialidade</label>
          <select value={especialidade} onChange={(e) => setEspecialidade(e.target.value as EspecialidadeProf)}>
            {ESPECIALIDADES_ORDEM.map((e) => (
              <option key={e} value={e}>{ESPECIALIDADE_LABEL[e]}</option>
            ))}
          </select>
        </div>
        <div className="campo">
          <label>registro de classe <span style={{ color: "var(--text-suave)" }}>(opcional)</span></label>
          <input type="text" value={registro} onChange={(e) => setRegistro(e.target.value)} placeholder="CRFa / CREFITO / CRP / CRN" />
        </div>
        <div className="campo" style={{ margin: 0 }}>
          <label>contato <span style={{ color: "var(--text-suave)" }}>(opcional)</span></label>
          <input type="text" value={contato} onChange={(e) => setContato(e.target.value)} placeholder="e-mail ou telefone" />
        </div>
      </div>

      <button className="btn btn-primario btn-bloco btn-grande" disabled={!nome.trim()} onClick={salvar}>
        salvar profissional
      </button>
    </main>
  );
}
